'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bell-on';
var width = 640;
var height = 512;
var aliases = [128365];
var unicode = 'f8fa';
var svgPathData = 'M320 0c-4.4 0-8 3.6-8 8l0 24.2C227.4 36.4 160 106.3 160 192l0 17.4c0 40.8-12.1 80.8-34.8 114.8l-23.1 34.6c-4 6.1-6.2 13.2-6.2 20.4 0 20.3 16.5 36.8 36.8 36.8l374.3 0c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4l-23.1-34.6c-22.7-34-34.8-73.9-34.8-114.8l0-17.4c0-85.7-67.4-155.6-152-159.8L328 8c0-4.4-3.6-8-8-8zM176 192c0-79.5 64.5-144 144-144s144 64.5 144 144l0 17.4c0 44 13 87 37.4 123.6l23.1 34.6c2.3 3.4 3.5 7.4 3.5 11.6 0 11.5-9.3 20.8-20.8 20.8l-374.3 0c-11.5 0-20.8-9.3-20.8-20.8 0-4.1 1.2-8.1 3.5-11.6L138.6 333C163 296.4 176 253.4 176 209.4l0-17.4zm76.1 272c9.9 28 36.6 48 67.9 48s58-20 67.9-48l-17.3 0c-9 18.9-28.3 32-50.6 32s-41.6-13.1-50.6-32l-17.3 0zM8 184c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8zm536-8c-4.4 0-8 3.6-8 8s3.6 8 8 8l80 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-80 0zM599.2 12.4c-2-4-6.8-5.6-10.7-3.6l-64 32c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l64-32c4-2 5.6-6.8 3.6-10.7zM44.4 23.2l64 32c4 2 8.8 .4 10.7-3.6s.4-8.8-3.6-10.7l-64-32c-4-2-8.8-.4-10.7 3.6s-.4 8.8 3.6 10.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;